import { Button } from '@gisce/oficina-virtual-components'
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Box, ButtonProps } from '@mui/material';
import { RadioButtonUnchecked, RadioButtonChecked } from '@mui/icons-material';

type ActionButton = Pick<ButtonProps, "disabled" | "onClick">;

export const ActionButton = ({
  disabled, 
  onClick
}: ActionButton) => {
  const { t } = useTranslation();

  const [focused, setFocused] = useState(false);

  return <Button
    key={"actionSelect"}
    variant={'contained'}
    color={'primary'}
    disabled={disabled}
    title={t("common:text.contract_view_detail")}
    onMouseEnter={() => setFocused(true)}
    onMouseLeave={() => setFocused(false)}
    onFocus={() => setFocused(true)}
    onBlur={() => setFocused(false)}
    onClick={onClick}
    style={{ marginTop: '5px', marginLeft: '5px', marginRight: '5px', overflow: 'hidden' }}
  >
    {focused ? <RadioButtonChecked sx={{mr: 1}} /> :  <RadioButtonUnchecked sx={{mr: 1}}/>}
    <Box>{t('common:text.contracts_view_action_select_button')}</Box>
  </Button>
}
